import { useContext } from 'react'
import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useJsApiLoader } from '@react-google-maps/api'
import { FormikErrors } from 'formik'

import {
  GoogleMapAutocomplete,
  GoogleMapLatAndLongInput,
  TextInputWithHelper,
  HelperWrapper,
} from 'src/components'
import { Slider } from './slider.component'

import { FormGoogleMap } from 'src/components/google-map/form-google-map.component'
import { IStepForm } from 'src/types'
import { jsApiLoaderOptions } from 'src/constants'
import useStyles from './styles'
import { LocationsMapContext } from './context/map.context'
import { ILocationItem } from 'src/types/locations.type'

interface Props {
  index: number
  isDisabled?: boolean
  errors: FormikErrors<ILocationItem>
  location_name: string
  location_address: string
  radius: number
  centerProp: {
    lat: number
    lng: number
  }
}

const LocationItem = ({
  index,
  errors,
  location_name,
  location_address,
  centerProp,
  isDisabled,
  radius,
}: Props) => {
  const [t] = useTranslation()
  const { handleAddress, handleLocationName, handleLatitudeAndLongitude, handleChangeRadius } =
    useContext(LocationsMapContext)
  const classes = useStyles()
  const { isLoaded } = useJsApiLoader(jsApiLoaderOptions)

  return (
    <>
      <Grid>
        <TextInputWithHelper
          disabled={isDisabled}
          fullWidth
          disableBorder
          inputPlaceholder={t('steps-form-location-input-placeholder.v')}
          inputUpperLabel={
            <HelperWrapper
              t={'steps-form-location-input-label'}
              isInputLable
              isMandatory={!!location_address}
            />
          }
          value={location_name}
          inputName={location_name}
          handleChange={handleLocationName(index)}
          error={errors?.location_name ? t(errors.location_name + '.v') : ''}
        />
      </Grid>
      {isLoaded && (
        <GoogleMapAutocomplete
          isDisabled={isDisabled}
          address={location_address}
          handleAddress={handleAddress(index)}
          handleLatAndLong={handleLatitudeAndLongitude(index)}
          error={errors?.location_address ? t(errors.location_address + '.v') : ''}
          withLabel
        />
      )}
      <GoogleMapLatAndLongInput
        isRequired={!!location_address}
        isDisabled={isDisabled}
        center={centerProp}
        handleAddress={handleAddress(index)}
        handleLatAndLong={handleLatitudeAndLongitude(index)}
      />
      <div className={classes.mapWrapper}>
        <Slider
          isDisabled={isDisabled}
          handleChangeRadius={handleChangeRadius(index)}
          radius={radius}
        />
        {isLoaded && (
          <FormGoogleMap
            isDisabled={isDisabled}
            center={centerProp}
            handleAddress={handleAddress(index)}
            handleLatAndLong={handleLatitudeAndLongitude(index)}
            radius={radius}
          />
        )}
      </div>
    </>
  )
}

export { LocationItem }
